import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import { Button, Spacer, Switch } from '@odekoteam/doppio';
import CancelButton from '../CancelButton';
import { Flex } from 'theme-ui';
import { useEffect, useState } from 'react';
import { modalSelector } from 'src/state/selectors/modal';
import { GetLocation } from 'src/graphql/types/delivery';
import { GUpdateLocationsIncludeFinancialsOnDeliverySheetMutation } from 'src/graphql/types/generated';
import { useMutation } from 'urql';
import { hideModal } from 'src/state/slices/modal';
import { LoaderSpinner } from '../../Loader';
import { updateRoutingLocations } from 'src/state/slices/locations';
import ExpandableLocationsList from './ExpandableLocationsList';
import { UPDATE_LOCATIONS_INCLUDE_FINANCIALS_ON_DELIVERY_SHEET } from 'src/graphql/requests/updateLocationsIncludeFinancialsOnDeliverySheet';

const IncludeFinancialsTab = (): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const {
    variables: { locations },
  } = useAppSelector(modalSelector);
  const [includeFinancials, setIncludeFinancials] = useState<boolean>(true);
  const getLabel = (): string => (includeFinancials ? 'ON' : 'OFF');
  const [result, updateLocationsIncludeFinancials] =
    useMutation<GUpdateLocationsIncludeFinancialsOnDeliverySheetMutation>(
      UPDATE_LOCATIONS_INCLUDE_FINANCIALS_ON_DELIVERY_SHEET,
    );

  const handleAction = (): void => {
    const locationIds = locations.map(
      (location: GetLocation): string => location.id,
    );
    updateLocationsIncludeFinancials({
      input: {
        locationIds,
        includeFinancialsOnDeliverySheet: includeFinancials,
      },
    });
  };

  useEffect(() => {
    if (result.data) {
      const routingLocations = locations.map((location: GetLocation) => ({
        locationId: location.id,
        includeFinancialsOnDeliverySheet: includeFinancials,
      }));
      dispatch(updateRoutingLocations(routingLocations));
      dispatch(hideModal());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result]);

  return (
    <>
      <Flex sx={{ alignItems: 'center', marginBottom: '10px' }}>
        <span sx={{ variant: 'text.paragraphMdDefault' }}>
          Update include financials on delivery sheet to:
        </span>
        <div sx={{ marginX: '8px' }}>
          <Switch
            id="include-financials-switch-bulk"
            accessibilityLabel="include financials on delivery sheet toggle"
            onCheckedChange={(): void =>
              setIncludeFinancials(!includeFinancials)
            }
            size="default"
            isChecked={includeFinancials}
          />
        </div>
        <span sx={{ variant: 'text.paragraphLgDefault' }}>{getLabel()}</span>
      </Flex>
      <div sx={{ variant: 'text.paragraphMdDefault', marginBottom: '20px' }}>
        You will be updating {locations.length} locations. Would you like to
        turn financials on delivery sheets{' '}
        <b sx={{ variant: 'text.labelMd' }}>{getLabel()}</b> for these{' '}
        {locations.length} locations?
      </div>
      <ExpandableLocationsList locations={locations} />
      <Flex sx={{ justifyContent: 'center', marginTop: '24px' }}>
        {result.fetching && (
          <LoaderSpinner
            imgStyle={{
              marginLeft: '-200px',
              bottom: '32px',
              height: '20px',
              top: 'auto',
              left: 'auto',
            }}
          />
        )}
        <Button
          id="modal-update-include-financials-action-button"
          variant="secondary"
          onPress={handleAction}
          isDisabled={result.fetching}
        >
          Update
        </Button>
        <Spacer width="$1" />
        <CancelButton />
      </Flex>
    </>
  );
};
export default IncludeFinancialsTab;
